export default "{\n    \"noResults\": \"No se encontraron resultados\",\n    \"loading\": \"Cargando...\",\n    \"typeToSearch\": \"Escriba para buscar\"\n}"